






import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'UCButtonGroup',
  props: {
    rowOnly: {
      type: Boolean,
      default: false,
    },
  },
});
